import { BOSS_MODE_LABEL } from 'data/global';
import { DEAL_ROOM_SEARCH, DealRoomSearch } from 'models/Search';

export const ALL_DEALS = 'all';

export const getSearchSectionTitle = (
  type: DealRoomSearch | string,
  isSuperAdmin?: boolean,
) =>
  isSuperAdmin && type === DEAL_ROOM_SEARCH.MARKETPLACE
    ? BOSS_MODE_LABEL
    : type;

const isSelectedFilter = (key: string, filter: string) =>
  key === filter || filter === ALL_DEALS;

export const isValidDealSection = (
  key: string,
  value: number,
  filter: string,
  isLoggedIn: boolean,
  isSuperAdmin: boolean,
) => {
  const isMarketplace = key === DEAL_ROOM_SEARCH.MARKETPLACE;
  const isBuying = key === DEAL_ROOM_SEARCH.BUYING;
  const isDrafts = key === DEAL_ROOM_SEARCH.DRAFTS;

  if (!isLoggedIn) {
    return isMarketplace; // If not logged in, only allow MARKETPLACE
  }

  if (!value && isDrafts) return false; // if Drafts is empty hide drafts tab and section

  if (isSelectedFilter(key, filter)) {
    if (isSuperAdmin) {
      return !isBuying; // If logged in and super admin disallow BUYING
    }

    return true; // If logged in and not super admin allow all
  }

  return false; // Key does not pass any condition
};
